import { nullable, string, struct } from 'io-ts/lib/Decoder';

import { RefItem as UserRefItem } from '../user/RefItem';

export const Sender = struct({
	user: UserRefItem,
	connectionId: nullable(string),
});
